import importerActions from 'src/modules/shared/importer/importerActions';
import selectors from 'src/modules/position/importer/positionImporterSelectors';
import PositionService from 'src/modules/position/positionService';
import fields from 'src/modules/position/importer/positionImporterFields';
import { i18n } from 'src/i18n';

const positionImporterActions = importerActions(
  'POSITION_IMPORTER',
  selectors,
  PositionService.import,
  fields,
  i18n('entities.position.importer.fileName'),
);

export default positionImporterActions;